import classNames from 'classnames';

export const FooterMenuLabel: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <span
      className={classNames(
        'text-[16px]/[20.16px] font-medium uppercase tracking-[.02em] text-white opacity-70',
        className,
      )}
    >
      {children}
    </span>
  );
};
